import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { database } from '../services/firebase';
import { useAuth } from './useAuth';

type FirebaseQuestions = Record<string, {
  author: {
    name: string;
    avatar: string;
  }
  content: string;
  isHighlighted: boolean;
  isAnswered: boolean;
  likes: Record<string, {
    authorId: string;
  }>;
}>

type QuestionType = {
  id: string;
  author: {
    name: string;
    avatar: string;
  }
  content: string;
  isHighlighted: boolean;
  isAnswered: boolean;
  likeCount: number;
  likeId: string | undefined;
}

export function useRoom(roomId: string) {
  const { user } = useAuth();
  const [questions, setQuestions] = useState<QuestionType[]>([]);
  const [title, setTitle] = useState('');
  const [isClosed, setIsClosed] = useState('');
  const [admin, setAdmin] = useState('');
  const history = useHistory();

  useEffect(() => {
    const roomRef = database.ref(`rooms/${roomId}`);
    // ver mais para melhorar performance = https://firebase.google.com/docs/database/admin/retrieve-data?hl=pt-br#node.js_1
    roomRef.on('value', room => {
      const databaseRoom = room.val();
      if (databaseRoom != null) {
        // retorno das question como objeto, serão convertidos em arrays
        const firebaseQuestions: FirebaseQuestions = databaseRoom.questions ?? {};
        const parsedQuestions = Object.entries(firebaseQuestions).map(([key, value]) => {
          return {
            id: key,
            content: value.content,
            author: value.author,
            isHighlighted: value.isHighlighted,
            isAnswered: value.isAnswered,
            likeCount: Object.values(value.likes ?? {}).length,
            likeId: Object.entries(value.likes ?? {}).find(([key, like]) => like.authorId === user?.id)?.[0],
          }
        })

        setAdmin(databaseRoom.authorId);
        setIsClosed(databaseRoom.closedAt);
        setTitle(databaseRoom.title);
        setQuestions(parsedQuestions);
      } else {
        history.push('/');
      }
    });

    return () => {
      roomRef.off('value');
    }
  }, [roomId, user?.id, history]);

  return { questions, title, isClosed, admin };
}